import Vue from 'vue'
// 用于监听、触发事件
export default new Vue()
